import { ChangeEvent, FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import { FormCheckbox } from 'src/components/FormCheckbox/FormCheckbox';
import { Section } from 'src/components/Section/Section';
import { parkingRatio } from 'src/pages/AdministratorPage/consts';
import { adminActions } from 'src/store/admin/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { Parking } from 'src/types';

import { CoordsFields } from './CoordsFields/CoordsFields';
import classes from './Fields.module.scss';
import { FontSizeField } from './FontSizeField';
import { ResponsibleField } from './ResponsibleField';
import { RotationField } from './RotationField/RotationField';
import { TitleField } from './TitleField';
import { WidthField } from './WidthField';

export interface ParkingFieldsProps {
  bookingObject: Parking;
}

export const ParkingFields: FC<ParkingFieldsProps> = ({ bookingObject }) => {
  const guest = useField<boolean>('guest').input.value;
  const dispatch = useAppDispatch();

  const changeGuest = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(adminActions.update({ guest: e.target.checked }));
    },
    [dispatch],
  );

  return (
    <>
      <Section
        title='Укажите данные ОБ'
        testId='administratorDeskData'
        contentClassName={classes.attributes}
      >
        <TitleField label='Номер парковочного места' />
        <FormCheckbox
          name='guest'
          label='Гостевое место'
          dataTestId='administratorGuestCheckbox'
          onChange={changeGuest}
        />
      </Section>

      <Section title='Координаты и размер' testId='administratorCoordsAndSize'>
        <CoordsFields bookingObject={bookingObject} />
        <WidthField ratio={parkingRatio} />
        <FontSizeField />
      </Section>

      <Section title='Вращение' testId='administratorRotation'>
        <RotationField
          refreshId={bookingObject.id}
          value={bookingObject.rotation}
          min={0}
          max={180}
          step={180}
        />
      </Section>

      {!guest && (
        <Section title='Закрепить за' testId='administratorResponsible'>
          <ResponsibleField
            id={bookingObject.mapPlaceId}
            value={bookingObject.responsible}
          />
        </Section>
      )}
    </>
  );
};
